const endpoints = {
	companyStatisticsCards: '/admin/statistics/companyStatisticsCards',
    companyStatisticsGraphs: '/admin/statistics/companyStatisticsGraphs',
    companyStatisticsGeo: '/admin/statistics/companyStatisticsGeo',
    exportComplaints: '/admin/exports/exportComplaints'
}

export {endpoints};